import vars from '../utils/vars';

/* Removes double quotes at the start and end of the provided string */
const removeDoubleQuotes = (str = '') => str.slice(1, str.length - 1);

export const DEVICE_SIZE_SMALL = removeDoubleQuotes(vars['mq-device-small']);
export const DEVICE_SIZE_BIG = removeDoubleQuotes(vars['mq-device-big']);
export const SMALL = removeDoubleQuotes(vars['mq-small']);
export const MEDIUM = removeDoubleQuotes(vars['mq-medium']);
export const LARGE = removeDoubleQuotes(vars['mq-large']);
export const LARGE_X = removeDoubleQuotes(vars['mq-large-x']);
export const LARGE_XX = removeDoubleQuotes(vars['mq-large-xx']);
export const RETINA = removeDoubleQuotes(vars['mq-retina']);